import OrderScreen from './list/index';
import CreateScreen from './list/create';
import DetailScreen from './list/detail';
import UpdateScreen from './list/update';

import ShipmentScreen from './shipment/index';
import DetailShipmentScreen from './shipment/detail';
import UpdateShipmentScreen from './shipment/update';

import ContractScreen from './contract/index';
import CreateContractScreen from './contract/create';
import DetailContractScreen from './contract/detail';
import UpdateContractScreen from './contract/update';

import CustomerScreen from './customer/index';
import CreateCustomerScreen from './customer/create';

// import ReceiveScreen from './receive';
// import UpdateScreen from './update';

const routes = [
  // list
  {
    path: '/order',
    component: OrderScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery'],
  },
  {
    path: '/order/create',
    component: CreateScreen,
    action: ['manage'],
    service: ['nvo.tms.delivery'],
  },
  // shipment
  {
    path: '/order/shipment',
    component: ShipmentScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery'],
  },
  {
    path: '/order/shipment/:id',
    component: DetailShipmentScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery'],
  },
  {
    path: '/order/shipment/:id/update',
    component: UpdateShipmentScreen,
    action: ['manage'],
    service: ['nvo.tms.delivery'],
  },

  // contract
  {
    path: '/order/contract',
    component: ContractScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.contract'],
  },
  {
    path: '/order/contract/create',
    component: CreateContractScreen,
    action: ['manage'],
    service: ['nvo.tms.contract'],
  },
  {
    path: '/order/contract/:id',
    component: DetailContractScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.contract'],
  },
  {
    path: '/order/contract/:id/update',
    component: UpdateContractScreen,
    action: ['manage'],
    service: ['nvo.tms.contract'],
  },

  // customer
  {
    path: '/order/customer',
    component: CustomerScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery'],
  },
  {
    path: '/order/customer/create',
    component: CreateCustomerScreen,
    action: ['manage'],
    service: ['nvo.tms.delivery'],
  },

  {
    path: '/order/:id',
    component: DetailScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.delivery'],
  },
  {
    path: '/order/:id/update',
    component: UpdateScreen,
    action: ['manage'],
    service: ['nvo.tms.delivery'],
  },
];

export default routes;
